/**
 * Safely parses a JSON string.
 * returns the fallback value if parsing fails.
 *
 * @param {string} jsonString - The JSON string to parse.
 * @param {any} fallbackValue - The value to return if parsing fails. Defaults to null.
 * @returns {any} - The parsed object/value or the fallback value.
 */
export const safeJsonParse = (jsonString, fallbackValue = null) => {
  if (!jsonString) return fallbackValue;

  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return fallbackValue;
  }
};
